
import { Pane } from 'evergreen-ui'
import {
  MESSAGES,
  isRobIn,
  isPortfolioMajor,
} from '../../../config/admissionRound'

const StatusRegister_1 = ({ DataRegister }) => {
  console.log(DataRegister[0])
  return (
    <>

      {
        (DataRegister[0].REGISTER_TYPE_ID === "1" || DataRegister[0].REGISTER_TYPE_ID === "5") ?
          (
            <>
              {
                isRobIn("statusPortfolioRound", DataRegister[0].ROB_ID) ?
                  isPortfolioMajor(DataRegister[0].Major1_MAJOR_ID) ?
                    (
                      <>
                        <Pane
                          color="#fff"
                          backgroundColor="#008616ff"
                          height="100%"
                          paddingY={4}
                          paddingX={5}
                          fontSize={14}
                          fontFamily=""
                          margin={0}
                          fontWeight={700}
                          justifyContent="center"
                          alignItems="center"
                          display="flex"
                          flexDirection="column"
                        >
                          {MESSAGES.interviewEligible}
                        </Pane>
                      </>
                    )
                    :
                    (

                      <Pane
                        color="#fff"
                        backgroundColor="#008616ff"
                        height="100%"
                        paddingY={4}
                        paddingX={5}
                        fontSize={14}
                        fontFamily=""
                        margin={0}
                        fontWeight={700}
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                        flexDirection="column"
                      >
                        {MESSAGES.waitAnnouncePass}
                      </Pane>


                    )
                  :
                  (
                    <>
                      {
                        isRobIn("statusInterviewEligible", DataRegister[0].ROB_ID) ? (
                          <Pane
                            color="#fff"
                            backgroundColor="#008616ff"
                            height="100%"
                            paddingY={4}
                            paddingX={5}
                            fontSize={14}
                            fontFamily=""
                            margin={0}
                            fontWeight={700}
                            justifyContent="center"
                            alignItems="center"
                            display="flex"
                            flexDirection="column"
                          >
                            {MESSAGES.interviewEligible}
                          </Pane>
                        ) : (
                          <></>
                        )
                      }

                    </>
                  )
              }

            </>

          ) :
          (


            (DataRegister[0].REGISTER_TYPE_ID !== "1" || DataRegister[0].REGISTER_TYPE_ID !== "5") ?
              (
                <>
                  <Pane
                          color="#fff"
                          backgroundColor="#008616ff"
                          height="100%"
                          paddingY={4}
                          paddingX={5}
                          fontSize={14}
                          fontFamily=""
                          margin={0}
                          fontWeight={700}
                          justifyContent="center"
                          alignItems="center"
                          display="flex"
                          flexDirection="column"
                        >
                          {MESSAGES.interviewEligible}
                        </Pane>
                </>
              ) : (
                <>
                  <Pane
                    color="#fff"
                    backgroundColor="#008616ff"
                    height="100%"
                    paddingY={4}
                    paddingX={5}
                    fontSize={14}
                    fontFamily=""
                    margin={0}
                    fontWeight={700}
                    justifyContent="center"
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                  >
                    {MESSAGES.interviewEligible}
                  </Pane>
                </>
              )

          )
      }


    </>
  )
}

export default StatusRegister_1
